import { render, staticRenderFns } from "./PlanLoading.vue?vue&type=template&id=fad3c530&scoped=true"
import script from "./PlanLoading.vue?vue&type=script&lang=js"
export * from "./PlanLoading.vue?vue&type=script&lang=js"
import style0 from "./PlanLoading.vue?vue&type=style&index=0&id=fad3c530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad3c530",
  null
  
)

export default component.exports